<template>
  <div class="welcome-wrapper">
    <div class="content-wrapper">
      <!-- 主要内容区域，可滚动 -->
      <div class="main-content">
        <!-- 左侧：宣传内容区域 -->
        <div class="promo-section">
          <!-- 品牌logo和标题 -->
          <div class="brand-header" @click="goToHome">
            <v-img 
              :src="require('@/assets/logo.png')" 
              max-height="100px" 
              max-width="100px" 
              alt="logo" 
              contain
              class="brand-logo"
            ></v-img>
            <div class="brand-title">
              {{ $i18n.t("welcome.product_name") }}
              <!-- <span class="tm-mark">TM</span> -->
            </div>
          </div>

          <!-- 主标语 -->
          <h1 class="hero-title">
            {{ $i18n.t("welcome.product_slogan") }}
          </h1>
          <p class="hero-subtitle">
            {{ $i18n.t("welcome.product_slogan_two") }}
          </p>

          <!-- 图片轮播区域 -->
          <div class="carousel-container">
            <div class="carousel-wrapper">
              <div 
                class="carousel-slide" 
                v-for="(slide, index) in carouselSlides" 
                :key="index"
                :class="{ active: currentSlide === index }"
              >
                <div class="slide-content">
                  <div class="slide-icon">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                      <path :d="slide.iconPath"/>
                    </svg>
                  </div>
                  <h3>{{ slide.title }}</h3>
                  <p>{{ slide.description }}</p>
                </div>
              </div>
            </div>

            <!-- 轮播指示器 -->
            <div class="carousel-indicators">
              <button 
                v-for="(slide, index) in carouselSlides" 
                :key="index"
                @click="setSlide(index)"
                :class="{ active: currentSlide === index }"
                class="indicator"
              ></button>
            </div>
          </div>

          <!-- 功能特性列表 -->
          <div class="features-grid">
            <div class="feature-card" v-for="(feature, index) in features" :key="index">
              <div class="feature-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path :d="feature.iconPath"/>
                </svg>
              </div>
              <span class="feature-text">{{ feature.text }}</span>
            </div>
          </div>
        </div>

        <!-- 右侧：登录表单区域 -->
        <div class="auth-section">
            <MarqueeNotice style="max-width: 400px;" :message="marqueeNoticeText"></MarqueeNotice>
          <div class="auth-card">
            <LoginCard ref="refLoginCard" v-if="currentMode === 'login'" @switchMode="handleSwitchMode" />
            <SignupCard v-if="currentMode === 'signup'" @switchMode="handleSwitchMode" />

            <div v-if="false" class="auth-header">
              <h2>欢迎回来</h2>
              <p>开始您的AI创作之旅</p>
            </div>

            <div class="auth-content">
              <h3 v-if="false" class="product-name">
                {{ $i18n.t("welcome.product_name") }}
                <span class="tm-mark">TM</span>
              </h3>

              <p v-if="false" class="auth-description">
                {{ $i18n.t("welcome.product_slogan") }}
              </p>

              <div v-if="false" class="auth-features">
                <div class="auth-feature-item" v-for="(feature, index) in authFeatures" :key="index">
                  <div class="auth-feature-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path :d="feature.iconPath"/>
                    </svg>
                  </div>
                  <span>{{ feature.text }}</span>
                </div>
              </div>

              <button v-if="false" class="get-started-btn" @click="handleGetStarted">
                {{ $i18n.t("welcome.start_btn_txt") }}
              </button>

              <div class="auth-footer">
                <p class="auth-note"> {{ $i18n.t("welcome.welcome_agree_terms_of_service") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部版权信息固定在底部 -->
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-left">
          <p> {{ $i18n.t("welcome.copy_right") }}</p>
        </div>
        <div class="footer-right">
          <a href="https://www.nextmindapp.com/terms-and-conditions" class="footer-link"> {{ $i18n.t("welcome.terms_of_service") }}</a>
          <a href="https://www.nextmindapp.com/privacy-policy" class="footer-link"> {{ $i18n.t("welcome.privacy_policy") }}</a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>// Pubsub
import { subscribe, unsubscribe } from "@/service/wd_pubsub.js";
import { signupPubIds } from '@/service/wd_pubsub_config.js';
import LoginCard from "@/views/auth/mv-wd-login.vue";
import SignupCard from "@/views/auth/mv-wd-signup.vue";
import MarqueeNotice from "@/components/MarqueeNotice.vue";
import { userKeys } from "@/service/wd_app_config.js";

export default {
  name: 'WelcomePage',
  components: {
    LoginCard,
    SignupCard,
    MarqueeNotice
  },
  computed: {
    marqueeNoticeText() {
      return this.$i18n?.t("welcome.register_trial_description") || "Register now to get 200 free AI credits (valid for 30 days) and enjoy all Pro features.";
    },
    carouselSlides() {
      return [
        {
          title: this.$i18n?.t("welcome_carousel_slides.slide_1_title") || '数据安全',
          description: this.$i18n?.t("welcome_carousel_slides.slide_1_description") || '企业级安全保护，让您的数据始终安全可靠',
          iconPath: 'M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z'
        },
        {
          title: this.$i18n?.t("welcome_carousel_slides.slide_2_title") || '数据安全',
          description: this.$i18n?.t("welcome_carousel_slides.slide_2_description") || '企业级安全保护，让您的数据始终安全可靠',
          iconPath: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
        },
        {
          title: this.$i18n?.t("welcome_carousel_slides.slide_3_title") || '数据安全',
          description: this.$i18n?.t("welcome_carousel_slides.slide_3_description") || '企业级安全保护，让您的数据始终安全可靠',
          iconPath: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z'
        }
      ];
    },
    features() {
      return [
        {
          text: this.$i18n?.t("welcome.product_feature_introducation_two") || '智能数据上传',
          iconPath: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2l6 6 M12 18v-6 M9 15l3-3 3 3'
        },
        {
          text: this.$i18n?.t("welcome.product_feature_introducation_one") || '高效文档处理',
          iconPath: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2l6 6 M8 12h8 M8 16h8 M8 20h6'
        },
        {
          text: this.$i18n?.t("welcome.product_feature_introducation_three") || '模板可视化优化',
          iconPath: 'M3 3h18v18H3z M8.5 8.5r1.5 M21 15l-5-5-11 11 M17 8r3 M20 11v2a2 2 0 0 1-2 2h-1'
        }
      ];
    },
    authFeatures() {
      return [
        {
          text: this.$i18n?.t("welcome.product_feature_introducation_one") || '高效文档处理',
          iconPath: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
        },
        {
          text: this.$i18n?.t("welcome.product_feature_introducation_two") || '智能数据上传',
          iconPath: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
        },
        {
          text: this.$i18n?.t("welcome.product_feature_introducation_three") || '可视化图表分析',
          iconPath: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
        }
      ];
    }
  },
  data() {
    return {
      currentMode: "login",  // "login" 或 "signup"
      currentSlide: 0,
      carouselTimer: null,
      // carouselSlides: [
      //   {
      //     title: this.$i18n?.t("welcome_carousel_slides.slide_1_title") || '数据安全',
      //     description: this.$i18n?.t("welcome_carousel_slides.slide_1_description") || '企业级安全保护，让您的数据始终安全可靠',
      //     iconPath: 'M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z'
      //   },
      //   {
      //     title: this.$i18n?.t("welcome_carousel_slides.slide_2_title") || '数据安全',
      //     description: this.$i18n?.t("welcome_carousel_slides.slide_2_description") || '企业级安全保护，让您的数据始终安全可靠',
      //     iconPath: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
      //   },
      //   {
      //     title: this.$i18n?.t("welcome_carousel_slides.slide_3_title") || '数据安全',
      //     description: this.$i18n?.t("welcome_carousel_slides.slide_3_description") || '企业级安全保护，让您的数据始终安全可靠',
      //     iconPath: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z'
      //   }
      // ],
      // features: [
      //   {
      //     text: this.$i18n?.t("welcome.product_feature_introducation_two") || '智能数据上传',
      //     iconPath: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2l6 6 M12 18v-6 M9 15l3-3 3 3'
      //   },
      //   {
      //     text: this.$i18n?.t("welcome.product_feature_introducation_one") || '高效文档处理',
      //     iconPath: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2l6 6 M8 12h8 M8 16h8 M8 20h6'
      //   },
      //   {
      //     text: this.$i18n?.t("welcome.product_feature_introducation_three") || '模板可视化优化',
      //     iconPath: 'M3 3h18v18H3z M8.5 8.5r1.5 M21 15l-5-5-11 11 M17 8r3 M20 11v2a2 2 0 0 1-2 2h-1'
      //   }
      // ],
      // authFeatures: [
      //   {
      //     text: this.$i18n?.t("welcome.product_feature_introducation_one") || '高效文档处理',
      //     iconPath: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
      //   },
      //   {
      //     text: this.$i18n?.t("welcome.product_feature_introducation_two") || '智能数据上传',
      //     iconPath: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
      //   },
      //   {
      //     text: this.$i18n?.t("welcome.product_feature_introducation_three") || '可视化图表分析',
      //     iconPath: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
      //   }
      // ]
    }
  },
  mounted() {
    this.startCarousel();
    subscribe(signupPubIds.pubId_Local_General_SignUpSuccess, this.pubCallback);
  },
  beforeDestroy() {
    this.stopCarousel();
  },
  methods: {
    goToHome() {
      window.open('https://www.nextmindapp.com/', '_blank', 'noopener,noreferrer')
    },
    handleSwitchMode(newMode) {
      // newMode 会从子组件 emit 出来，比如 "signup" 或 "login"
      if (newMode === "signup" || newMode === "login") {
        this.currentMode = newMode;
      }
    },
    handleGetStarted() {
      localStorage.setItem(userKeys.key_welcome_Remember, true);
      this.$router.replace("/login");
    },
    startCarousel() {
      this.carouselTimer = setInterval(() => {
        this.currentSlide = (this.currentSlide + 1) % this.carouselSlides.length;
      }, 4000);
    },
    stopCarousel() {
      if (this.carouselTimer) {
        clearInterval(this.carouselTimer);
        this.carouselTimer = null;
      }
    },
    setSlide(index) {
      this.currentSlide = index;
      this.stopCarousel();
      setTimeout(() => {
        this.startCarousel();
      }, 2000);
    },
    pubCallback(msgName, data) {
      if (msgName == signupPubIds.pubId_Local_General_SignUpSuccess) {
        this.currentMode = "login";
        this.$nextTick(() => {
          if (this.$refs.refLoginCard) {
            this.$refs.refLoginCard.onLogin({
              accountName: data.accountName,
              password: data.password,
              accountType: data.loginType
            });
          }
        });
        this.$message.success('Auto login in progress, please wait...');
      }
    },
  }
}
</script>

<style scoped>
/* 最外层包裹器，撑满视口，高度 100% 或 100vh */
.welcome-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

/* 可滚动内容区 */
.content-wrapper {
  flex: 1;
  overflow: auto;
  /* 可选：背景图应用在这层或你原有层 */
  background-image: url('@/assets/web_bg.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

/* 主要内容布局区 */
.main-content {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  min-height: 100%;
  /* 如果你想加 padding 或 margin，使内容不紧贴滚动边缘 */
  /* padding: 20px; */
}

/* 左侧宣传区域 */
.promo-section {
  padding: 20px 40px;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* Brand header, 标题等保留你原来的样式： */
.brand-header {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
}

.brand-logo {
  margin-right: 16px;
}

.brand-title {
  font-size: 36px;
  font-weight: 600;
  position: relative;
  padding-right: 20px;
}

.tm-mark {
  position: absolute;
  top: -4px;
  right: 0;
  font-size: 12px;
  font-weight: normal;
  opacity: 0.8;
}

.hero-title {
  font-size: 32px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 20px 0;
  letter-spacing: -0.5px;
}

.hero-subtitle {
  font-size: 24px;
  opacity: 0.9;
  margin: -15px 0 30px 0;
  line-height: 1.5;
}

/* 轮播 */
.carousel-container {
  margin-bottom: 50px;
  position: relative;
  height: 200px;
}

.carousel-wrapper {
  position: relative;
  height: 100%;
  overflow: hidden;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.carousel-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transform: translateX(30px);
  transition: all 0.6s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-slide.active {
  opacity: 1;
  transform: translateX(0);
}

.slide-content {
  text-align: center;
  padding: 30px;
}

.slide-icon {
  margin-bottom: 20px;
  opacity: 0.9;
}

.slide-content h3 {
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 12px 0;
}

.slide-content p {
  font-size: 16px;
  opacity: 0.9;
  margin: 0;
  line-height: 1.5;
}

.carousel-indicators {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 20px;
}

.indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  transition: all 0.3s ease;
}

.indicator.active,
.indicator:hover {
  background: rgba(255, 255, 255, 0.9);
  transform: scale(1.2);
}

/* 特性网格 */
.features-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}

.feature-card {
  display: flex;
  align-items: center;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.feature-card:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-2px);
}

.feature-icon {
  width: 20px;
  height: 20px;
  margin-right: 16px;
  opacity: 0.9;
  flex-shrink: 0;
}

.feature-text {
  font-size: 16px;
  line-height: 1.4;
  opacity: 0.95;
}

/* 右侧认证区域 */
.auth-section {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.auth-card {
  width: 100%;
  height: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  margin-top: 10%;
  /* justify-content: center; */
}

.auth-header {
  text-align: center;
  margin-bottom: 40px;
}

.auth-header h2 {
  font-size: 32px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 8px 0;
}

.auth-header p {
  font-size: 16px;
  color: #666;
  margin: 0;
}

.auth-content {
  text-align: center;
}

.product-name {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 16px 0;
  position: relative;
  display: inline-block;
  padding-right: 20px;
}

.auth-description {
  font-size: 16px;
  color: #666;
  margin: 0 0 30px 0;
  line-height: 1.5;
}

.auth-features {
  margin-bottom: 40px;
  text-align: left;
}

.auth-feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-size: 14px;
  color: #333;
}

.auth-feature-item:last-child {
  margin-bottom: 0;
}

.auth-feature-icon {
  width: 16px;
  height: 16px;
  margin-right: 12px;
  color: #667eea;
  flex-shrink: 0;
}

.get-started-btn {
  width: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 24px;
}

.get-started-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
}

.get-started-btn:active {
  transform: translateY(0);
}

.auth-footer {
  margin-top: 24px;
}

.auth-note {
  font-size: 13px;
  color: #999;
  margin: 0;
  line-height: 1.4;
}

/* 底部版权 */
.footer {
  flex-shrink: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);
  padding: 10px 0;
  color: white;
  /* 如果你希望 footer 始终悬浮在最上面（遮在内容之上），可以用 position: sticky 或 fixed：
     position: sticky;
     bottom: 0;
     width: 100%;
  */
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-left p {
  margin: 0;
  font-size: 14px;
  opacity: 0.8;
}

.footer-right {
  display: flex;
  gap: 24px;
}

.footer-link {
  color: white;
  text-decoration: none;
  font-size: 14px;
  opacity: 0.8;
  transition: opacity 0.3s ease;
}

.footer-link:hover {
  opacity: 1;
  text-decoration: underline;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .main-content {
    grid-template-columns: 1fr;
  }
  
  .promo-section {
    padding: 40px 60px;
  }
  
  .hero-title {
    font-size: 36px;
  }
  
  .auth-section {
    padding: 40px 60px;
  }
}

@media (max-width: 768px) {
  .promo-section {
    padding: 30px 40px;
  }
  
  .hero-title {
    font-size: 28px;
  }
  
  .hero-subtitle {
    font-size: 18px;
  }
  
  .carousel-container {
    height: 160px;
  }
  
  .auth-section {
    padding: 30px 40px;
  }
  
  .footer-content {
    flex-direction: column;
    gap: 16px;
    text-align: center;
    padding: 0 20px;
  }
  
  .footer-right {
    gap: 16px;
  }
}

@media (max-width: 480px) {
  .promo-section {
    padding: 20px 30px;
  }
  
  .hero-title {
    font-size: 24px;
  }
  
  .carousel-container {
    height: 140px;
  }
  
  .auth-section {
    padding: 20px 30px;
  }
  
  .auth-card {
    max-width: none;
  }
}
</style>
